import type {Participant} from "@/raids/rest/RaidSchema.ts";

export function isTracking(participant: Participant) {
  return (participant.intervals.length > 0 &&
      (participant.intervals[participant.intervals.length - 1].endTime === null) &&
      (participant.intervals[participant.intervals.length - 1].startTime !== null))
}

export function isPausing(participant: Participant) {
  return (participant.intervals.length > 0 &&
      (participant.intervals[participant.intervals.length - 1].endTime !== null) &&
      (participant.intervals[participant.intervals.length - 1].startTime !== null))
}

export function hasNotStarted(participant: Participant) {
  return (participant.intervals.length === 0)
}

export function totalMinutes(participant: Participant) {
  return participant.intervals.reduce((sum, interval) => {
    if (interval.startTime !== null && interval.endTime !== null) {
      const start = interval.startTime.getTime();
      const end = interval.endTime.getTime();
      const diffMs = end - start;
      const diffMinutes = diffMs / 1000 / 60;
      return sum + diffMinutes;
    } else {
      return sum + 0;
    }
  }, 0);
}